module.exports = __webpack_public_path__ + "static/media/logo-white.90ef7bf1.png";